

<template>
	<div class="padding-top-10">
		<span class="padding-30">总箱数:{{totals.totalBoxNumber}}</span>
		<span class="padding-30">总重量(kg):{{totals.totalCartonWeight}}</span>
		<span class="padding-30">总体积(cbm):{{totals.totalCartonVolum}}</span>
		<TableList class="margin-top-20" v-bind="handleTableProps"></TableList>
	</div>
</template>

<script>
import { HttpAllotBoxing } from '@/service/allotment/allots'
import TableList from '@components/templates/tablelist'
export default {
	props: ['transferOutboundPlanNo'],
	data() {
		return {
			totals: {}
		}
	},
	components: {
		TableList
	},
	computed: {
		handleTableProps() {
			return {
				initFormData: { transferOutboundPlanNo: this.transferOutboundPlanNo },
				ajaxRequest: HttpAllotBoxing,
				startUp: this.transferOutboundPlanNo,
				interceptResponse: (data) => {
					this.totals = data.totalCartonInfo;
				},
				columns: [{
					title: "序号",
					type:'index',
					width: 90
				}, {
					title: "ERP SKU",
					key: 'sku'
				}, {
					title: "装箱数",
					key: 'packedQty',
				}, {
					title: "箱条码",
					key: 'boxBarcode',
				}, {
					title: "托盘条码",
					key: 'trayBarcode',
				}, {
					title: "外箱毛重（kg）",
					key: 'cartonGrossWeight',
				}, {
					title: "外箱尺寸(长*宽*高)",
					key: 'packedLength',
					render(h, { row }) {
						return <div>
							{row.cartonLength}*
							{row.cartonWidth}*
							{row.cartonHeight}(cm*cm*cm)
							</div>
					}
				}],
			}
		},

	},
};
</script>